var documentDecisionSignals = [
    /\bdocumento\b/,
    /\bdocument\b/,
    /\bidentidade\b/,
    /\bidentity\b/,
    /\bidentification\b/,
    /\brg\b/,
    /\bcin\b/,
    /\bcnh\b/,
    /\bpassaporte\b/,
    /\bpassport\b/,
    /\bfrente\b/,
    /\bverso\b/,
    /\bfront\b/,
    /\bback\b/,
    /\barquivo\s+digital\b/,
    /\bdigital\s+file\b/,
];
var twoSidedSignals = [
    /\bfrente(?:\s+e)?\s+verso\b/,
    /\bduas\s+faces\b/,
    /\bfront(?:\s+(?:and|&))?\s+back\b/,
    /\btwo\s+sides?\b/,
];
var singleSubmissionSignals = [
    /\benvio\s+unico\b/,
    /\bunico\b/,
    /\barquivo\s+unico\b/,
    /\bfoto\s+unica\b/,
    /\bdocumento\s+digital\b/,
    /\bjpeg\b/,
    /\bpng\b/,
    /\bpdf\b/,
    /\bsingle\b/,
    /\bsingle\s+submission\b/,
    /\bsingle\s+file\b/,
    /\bsingle\s+photo\b/,
    /\bdigital\s+document\b/,
];
var normalizeText = function (value) {
    return value
        .toLowerCase()
        .replace(/[áàâãäå]/g, 'a')
        .replace(/[éèêë]/g, 'e')
        .replace(/[íìîï]/g, 'i')
        .replace(/[óòôõö]/g, 'o')
        .replace(/[úùûü]/g, 'u')
        .replace(/ç/g, 'c')
        .replace(/[/_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};
var toText = function (value) { return (typeof value === 'string' ? value : ''); };
var isRecord = function (value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
};
var getMetadataText = function (metadata, depth) {
    if (depth === void 0) { depth = 0; }
    if (typeof metadata === 'string')
        return metadata;
    if (depth >= 3)
        return '';
    if (Array.isArray(metadata)) {
        return metadata.map(function (value) { return getMetadataText(value, depth + 1); }).join(' ');
    }
    if (!isRecord(metadata))
        return '';
    return Object.keys(metadata)
        .map(function (key) { return getMetadataText(metadata[key], depth + 1); })
        .join(' ');
};
var getStepText = function (currentStep) {
    return [
        toText(currentStep.stepName),
        toText(currentStep.title),
        toText(currentStep.description),
        toText(currentStep.formTitle),
        toText(currentStep.formSubtitle),
    ].join(' ');
};
var getFieldText = function (field) {
    return [
        toText(field.label),
        toText(field.description),
        toText(field.field),
        toText(field.alias),
        toText(field.fieldAlias),
        toText(field.name),
        toText(field.title),
        toText(field.subtitle),
        toText(field.placeholder),
        toText(field.helpText),
        toText(field.hint),
        toText(field.instruction),
        toText(field.instructions),
        getMetadataText(field.metadata),
    ].join(' ');
};
var hasSignal = function (value, signals) {
    var normalizedValue = normalizeText(value);
    return signals.some(function (signal) { return signal.test(normalizedValue); });
};
/**
 * Keeps document classification and rendering aligned with the decision
 * component: a field is eligible only when its option is visible.
 */
export var isVisibleDecisionField = function (field) { return Boolean(field.visible); };
/**
 * Documents are identified only from presentation signals already supplied by
 * the decision step or its visible options. `docSubmissionInstructions` is
 * intentionally not a signal: generic decisions can also carry that field.
 */
export var isDocumentDecision = function (currentStep) {
    var _a;
    if (hasSignal(getStepText(currentStep), documentDecisionSignals))
        return true;
    return Boolean((_a = currentStep.fields) === null || _a === void 0 ? void 0 : _a.some(function (field) { return isVisibleDecisionField(field) && hasSignal(getFieldText(field), documentDecisionSignals); }));
};
/**
 * Variants are presentation-only. They inspect explicit text already present
 * on the selected option, keeping the selected field itself unchanged.
 */
export var getDocumentSubmissionOptionVariant = function (field) {
    var fieldText = getFieldText(field);
    if (hasSignal(fieldText, [/\bcnh\b/]))
        return 'single';
    if (hasSignal(fieldText, twoSidedSignals))
        return 'two-sided';
    if (hasSignal(fieldText, singleSubmissionSignals))
        return 'single';
    return 'general';
};
export var isInitialDocumentSubmissionIntro = function (currentStep, showIntro) { return showIntro && isDocumentDecision(currentStep); };
export var getDocumentSubmissionScreen = function (currentStep, showIntro, selectedField) {
    if (isInitialDocumentSubmissionIntro(currentStep, showIntro))
        return 'general';
    if (selectedField && isDocumentDecision(currentStep))
        return getDocumentSubmissionOptionVariant(selectedField);
    return 'options';
};
/**
 * Kept as a focused entry point for the first, general pre-submission screen.
 */
export var getDocumentSubmissionIntroVariant = function (currentStep, showIntro) {
    return getDocumentSubmissionScreen(currentStep, showIntro) === 'general' ? 'general' : null;
};
/**
 * Creates the one-shot handoff used by the variant CTA. The selected field is
 * passed through unchanged, while repeated activation cannot submit twice.
 */
export var createOneTimeFieldSubmitter = function (onPressField) {
    var submitted = false;
    return function (selectedField) {
        if (!selectedField || submitted)
            return false;
        submitted = true;
        onPressField(selectedField);
        return true;
    };
};
